import type { ComponentChildren } from "preact";
import { Link } from "wouter-preact";

/**
 * The brand wordmark.
 *
 * It doubles as the "new question" link only on pages without the app menu
 * drawer (share, legal), where there is no other way to start over. Inside the
 * app shell the drawer owns navigation, so the wordmark is plain text there.
 *
 * `mark` prepends a small gold diamond, used where the wordmark doubles as the
 * brand mark (the sidebar drawer) rather than a plain text link.
 */
export function Wordmark({
  mark = false,
  href,
}: {
  mark?: boolean;
  href?: string;
}) {
  const inner: ComponentChildren = (
    <span class="wordmark">
      {mark && (
        <span class="wordmark__mark" aria-hidden="true">
          ◆
        </span>
      )}
      <span>
        FaB <span class="wordmark__accent">Judge</span>
      </span>
    </span>
  );

  if (!href) return inner;

  return (
    <Link
      href={href}
      class="wordmark-link"
      aria-label="Fab Judge — new question"
    >
      {inner}
    </Link>
  );
}
